<template>
  <v-row
    justify="center"
  >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ }">
        <upload-image-file
          :backgroundImage="backgroundImage"
          :size="size"
          @change="handleChangeImageFile"
          style="width: 100%"
          :simpleButton="simpleButton"
        />
        <!--v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
          </v-btn-->
      </template>
      <v-card
        color="black"
      >
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="handleCancel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('selectImage.title', locale) }}</v-toolbar-title>
          <v-spacer />
      <input style="display: none;" type="file" ref="file" id="originalImage" @change="handleUpdateImage($event)" accept="image/png, image/jpeg">
      <v-btn 
        @click="handleAddOriginalImage"
        size="small"
        color="gray"
        variant="text" 
      >
        <v-icon>mdi-file-upload</v-icon> original
      </v-btn>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="handleSave"
            >
            {{ $t('common.save', locale) }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <cropper
          class="cropper"
          :src="img"
          :stencilProps="{
            aspectRatio
          }"
          :width="size.w"
          :height="size.h"
          :defaultPosition="{ left: 0, top: 0 }"
          :defaultSize="{ width: size.w, height: size.h }"
          @change="handleChange"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex'
  import { Cropper } from 'vue-advanced-cropper'
  import 'vue-advanced-cropper/dist/style.css'
  import utils from '@/services/utils'
  import UploadImageFile from '@/components/uploadImageFile/Index'
  export default {
    components: {
      Cropper,
      UploadImageFile,
    },
    props: {
      size: {
        type: Object,
        default: null,
      },
      oldImg: {
        type: String,
        default: null,
      },
      simpleButton: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialog: false,
        fileInfo: null,
        img: null,
        ext: 'png',
        newImg: null,
        backgroundImage: null,
      }
    },
    computed: {
      ...mapState('app',['locale']),
      aspectRatio () {
        return utils.getAspectRatio(this.size.w, this.size.h)
      },
    },
    mounted () {
      if (this.oldImg) this.backgroundImage = this.oldImg
    },
    methods: {
    handleAddOriginalImage () {
      document.getElementById('originalImage').click()
    },
    handleUpdateImage (v) {
      // Reference to the DOM input element
      var input = v.target
      let aux = input.files[0].size / 1024
      aux = aux / 1024
      
      if (aux <= 0.5) {
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          const reader = new FileReader()
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            const ext = input.files[0].name.split('.').pop()
            if (['png', 'jpg', 'jpeg'].indexOf(ext)<0) {
              alert('Formato no v�lido.')
              return
            }
            this.newImg = e.target.result
            this.backgroundImage = this.newImg
            this.handleSave()
          }
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0])
        }
      } else alert(`Error: La imagen de ${parseInt(aux*1000, 10)}KB supera los 500KB permitidos`)
    },
      handleChangeImageFile (v) {
        const aux = v.name.split('.')
        this.ext =  aux.length > 1 ? aux.pop() : 'png'
        this.fileInfo = v
        this.img = v.base64 // `data:image/${this.ext};base64,${v.data}`
        this.dialog = true
      },
      handleChange({ canvas }) {
        this.newImg = canvas.toDataURL()
        this.backgroundImage = this.newImg
      },
      handleCancel () {
        this.newImg = null
        this.backgroundImage = this.oldImg
        this.dialog = false
      },
      handleSave () {
        if (this.newImg) {
          this.fileInfo.base64 = this.newImg // update img with crop
          this.backgroundImage = this.newImg
        }
        this.$emit('change', {
          ...this.fileInfo,
          ext: this.ext
        })
        this.dialog = false
      }
    },
  }
</script>
<style scoped>
  .cropper {
    /*
    height: 600px;
    background: #DDD;
    */
    background: red;
  }
</style>

